import React from 'react';
import logo from '../../img/logo.png'

const Footer = (props) => {
    return (
        <div className="navbar bottom footer">
           <img src={logo} className='logofooter' alt='logo'></img>
           <div> © 2020 <br/>
           Created by: <a href='https://www.jivkoandreev.com/' style={{color:'#f5c518'}}> Zhivko Andreev</a>
           </div>
        </div>
    );
}

export default Footer;
